import { Storage } from './libs';
export * from './libs';
export * from './types';
export * from './components';
export * from './hooks';
var packageConfig = require('../package.json');
Storage.set('fe_core_version', packageConfig.version);
